// extracted by mini-css-extract-plugin
module.exports = {"shadow":"query_shadow__2FNpf","textShadow":"query_textShadow__3S3wj","container":"query_container__3IfK6","text":"query_text__2iLqs","resetButton":"query_resetButton__16S-d"};